PrestationEnteteValidator.$inject = ['validator'];

export default function PrestationEnteteValidator(validator) {
	const instance = new validator();

	instance.ruleFor('code').notEmpty().withMessage('VALIDATION_NOTEMPTY');
	instance.ruleFor('code').length(1, 15).withMessage('VALIDATION_TOO_LONG_15');
	instance.ruleFor('libelle').notEmpty().withMessage('VALIDATION_NOTEMPTY');
	instance.ruleFor('libelle').length(0, 50).withMessage('VALIDATION_TOO_LONG_50');
	instance.ruleFor('uniteId').notEmpty().withMessage('VALIDATION_NOTEMPTY');
	instance.ruleFor('grilleRevisionId').notEmpty().when(showGrilleRevision).withMessage('VALIDATION_NOTEMPTY');
	instance
		.ruleFor('code')
		.matches(/^[a-zA-Z0-9_|]*$/)
		.withMessage('CODE_CHARACTERS_NOK');

	return instance;

	function showGrilleRevision(obj) {
		return (
			typeof obj.modeDeclenchement !== 'undefined' && (obj.modeDeclenchement == 3 || obj.modeDeclenchement == 4 || obj.modeDeclenchement == 5)
		);
	}
}
